module.exports = __webpack_public_path__ + "img/21_47.8cb79204.png";